import React from 'react';
import translations from '../../translations';
import '../../../css/flow/getting-started.less';

/**
 * @param Function onNewFlowClick
 */
const GettingStarted = ({
    onNewFlowClick,
    onFlowLibraryClick,
}) => (
    <div className="getting-started">
        <header className="getting-started-title">
            <p className="getting-started-surtitle">
                { translations['getting started surtitle'] }
            </p>
            <h2 className="getting-started-main-title">{ translations['getting started title'] }</h2>
        </header>
        <p className="margin-top">
            { translations['getting started message'] }
        </p>
        <span className="center-content margin-top">
            <button className="btn btn-success btn-sm margin-right" onClick={onNewFlowClick}>
                <span className="glyphicon glyphicon-plus" />
                <span> New Flow</span>
            </button>
            <button className="btn btn-secondary btn-sm" onClick={onFlowLibraryClick}>Flow Library</button>
        </span>
    </div>
);

export default GettingStarted;
